import React, { ReactElement } from "react"
import clsx from "clsx"
import Container from "@ecom/ui/components/Container"
import Button from "@material-ui/core/Button"
import { useObserver } from "../../../hooks/useObserver"
import scrollToPersonalForm from "../../../helpers/scrollToPersonalForm"
import * as styles from "./banner.module.scss"

interface IButtonProps {
  onClick?: () => void
  children: ReactElement | string
  variantStyle?: string
}

export const ButtonFloating = ({
  onClick = scrollToPersonalForm,
  variantStyle,
  children,
}: IButtonProps) => {
  const isVisible = useObserver(["formPkw", "interactive_benefits_block"])

  return (
    <div
      className={clsx(
        styles.btnBlock,
        { [styles.hideMobBlock]: isVisible },
        variantStyle && styles[variantStyle]
      )}
    >
      <Container>
        <Button onClick={onClick} className={styles.mobBtn}>
          {children}
        </Button>
      </Container>
    </div>
  )
}
